export enum ConfigurationGroup {
    BasicSettings = 'BasicSettings',
    LobbySettings = 'LobbySettings',
    WaitSmarterSettings = 'WaitSmarterSettings',
    AppointmentSettings = 'AppointmentSettings',
    LicenseSettings = 'LicenseSettings',
    ReserveWithGoogleSettings = 'ReserveWithGoogleSettings',
    AuthenticationSettings = 'AuthenticationSettings'
}